import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ArrowBack from "@material-ui/core/SvgIcon/SvgIcon";

export default function AlertMessage(props) {
    const [open, setOpen] = React.useState(props.open || false);

    const handleClickOpen = (e) => {
        if(!props.passed) {
            e.stopPropagation();
            setOpen(true);
        }

    };

    const handleClose = (e) => {

        if (props.handler) {
            props.handler();
        }
        setOpen(false);
    };

    return (
        <div>
            <div onMouseDownCapture={handleClickOpen}>
                {props.children}
            </div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" style={{textAlign: 'center', backgroundColor: 'f9f9f9'}}>{props.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description"  dangerouslySetInnerHTML={{__html: props.content || ''}} />
                </DialogContent>
                <DialogActions style={{justifyContent:'center'}}>
                    <Button onClick={handleClose} variant="contained" color="primary" style={{borderRadius: '50px'}}>
                        Закрыть
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}